import saveAs from 'file-saver';

export function downloadCsv(content: string, fileName: string): void {
  try {
    saveAs(new Blob([content], { type: 'text/csv;charset=utf-8;' }), fileName);
  } catch (error) {
    console.error('Failed to download CSV:', error);
    throw new Error('CSV download failed');
  }
}
